'use client';

import React, { createContext, useContext, useState, useCallback } from 'react';

export interface ActiveBroker {
  id: string;
  name: string;
  type: 'alpaca' | 'robinhood_agentic' | 'interactive_brokers' | 'td_ameritrade' | 'schwab' | 'fidelity' | string;
  environment: 'paper' | 'live';
}

interface BrokerContextValue {
  activeBroker: ActiveBroker | null;
  setActiveBroker: (broker: ActiveBroker | null) => void;
}

const BrokerContext = createContext<BrokerContextValue | null>(null);

export function BrokerProvider({ children }: { children: React.ReactNode }) {
  const [activeBroker, setActiveBrokerState] = useState<ActiveBroker | null>(null);

  const setActiveBroker = useCallback((broker: ActiveBroker | null) => {
    setActiveBrokerState(broker);
  }, []);

  return (
    <BrokerContext.Provider value={{ activeBroker, setActiveBroker }}>
      {children}
    </BrokerContext.Provider>
  );
}

export function useBroker(): BrokerContextValue {
  const ctx = useContext(BrokerContext);
  if (!ctx) {
    throw new Error('useBroker must be used within a BrokerProvider');
  }
  return ctx;
}
